module.exports = __webpack_public_path__ + "img/error_img.c123baea.png";